import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ContactUs } from 'src/app/shared/services/contact-us/contact-us';
import { ContactUsService } from 'src/app/shared/services/contact-us/contact-us.service';
import { DocumentPriceEnum, DOCUMENT_PRICES } from 'src/app/shared/util/document-prices.enum';
import { ErrorComponent, InformationComponent } from 'src/app/shared/util/helpers';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

export interface DocumentWidget {
  group: string;
  icon: string;
  titleKey: string;
  shortKey: string;
}

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
  contactItem: ContactUs = new ContactUs();
  documentPrices = DOCUMENT_PRICES;
  assistantHref = '';
  isLoading = false;
  contactSuccess = false;

  readonly documentWidgets: DocumentWidget[] = [
    { group: 'full_renting_contract', icon: 'lni-apartment', titleKey: 'DOCUMENTS.FEATURE1_TITLE', shortKey: 'DOCUMENTS.FEATURE1_SHORT' },
    { group: 'inventory', icon: 'lni-clipboard', titleKey: 'DOCUMENTS.FEATURE2_TITLE', shortKey: 'DOCUMENTS.FEATURE2_SHORT' },
    { group: 'sub_renting_contract', icon: 'lni-files', titleKey: 'DOCUMENTS.FEATURE3_TITLE', shortKey: 'DOCUMENTS.FEATURE3_SHORT' },
    { group: 'end_contract', icon: 'lni-close', titleKey: 'DOCUMENTS.FEATURE4_TITLE', shortKey: 'DOCUMENTS.FEATURE4_SHORT' },
    { group: 'data_beneficiar_real_contract', icon: 'lni-user', titleKey: 'DOCUMENTS.FEATURE5_TITLE', shortKey: 'DOCUMENTS.FEATURE5_SHORT' },
    { group: 'acord_gdpr', icon: 'lni-shield', titleKey: 'DOCUMENTS.FEATURE6_TITLE', shortKey: 'DOCUMENTS.FEATURE6_SHORT' },
  ];

  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    private trackerService: TrackerService,
    public contactUsService: ContactUsService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.assistantHref = environment.assistantApp;
    this.contactItem.subject = '';
    this.contactItem.content = '';
    this.contactItem.email = '';
  }

  redirectToPayment(documentUniqueName: string) {
    // Caută obiectul din DOCUMENT_PRICES cu documentUniqueName exact
    const priceDetails = Object.values(DOCUMENT_PRICES).find(
      doc => doc.documentUniqueName.toLowerCase() === documentUniqueName.toLowerCase()
    );

    // Check if user is authenticated
    const token = localStorage.getItem('id_token');

    if (!token) {
      // Save requested document information to localStorage
      localStorage.setItem('pendingDocument', JSON.stringify({
        documentFormat: priceDetails.documentFormat,
        documentUniqueName: priceDetails.documentUniqueName,
        documentUniqueGroup: priceDetails.documentUniqueGroup,
        documentType: priceDetails.documentType,
        documentPrice: priceDetails.documentPrice,
        documentCurrency: priceDetails.documentCurrency,
      }));

      // Redirect to login page with return URL
      this.router.navigate(['/login'], {
        queryParams: {
          returnUrl: '/documents'
        }
      });

      // Show message about login requirement
      this.snackBar.open(
        'You need to log in to download documents',
        'Close',
        { duration: 5000 }
      );

      return;
    }

    // Always go to card-payment, but pass a flag for free documents
    this.router.navigate(['/card-payment'], {
      queryParams: {
        documentFormat: priceDetails.documentFormat,
        documentUniqueName: priceDetails.documentUniqueName,
        documentUniqueGroup: priceDetails.documentUniqueGroup,
        documentType: priceDetails.documentType,
        documentPrice: priceDetails.documentPrice,
        documentCurrency: priceDetails.documentCurrency,
      }
    });
  }

  // downloadDocument(format: string = 'pdf', documentType: string) {
  //   // This is a placeholder. You'll need to implement the actual download logic
  //   console.log(`Attempting to download ${documentType} in ${format} format`);

  //   // Example: You might want to call a service method to generate and download the document
  //   // this.reportService.downloadDocument(documentType, format);

  //   // Show a success message
  //   this.snackBar.open(
  //     `Downloaded ${documentType} document in ${format} format`, 
  //     'Close', 
  //     { duration: 3000 }
  //   );
  // }

  // private generateReport(reportType: ReportTypeEnum, dataType: any, format: string = 'pdf') {
  //   console.group('Generating Report');
  //   console.log('Report Details:', { 
  //     reportType, 
  //     dataType, 
  //     format,
  //     dataTypeKeys: Object.keys(dataType || {})
  //   });

  //   // Validate input
  //   if (!reportType) {
  //     console.error('Report type is required');
  //     this.snackBar.open('Invalid report type', 'Close', { duration: 3000 });
  //     return;
  //   }

  //   this.reportService.getPDFFile(reportType, dataType, format).subscribe(
  //     param => {
  //       console.log('Report Service Response:', param);

  //       try {
  //         let jsonResponse = JSON.parse(JSON.stringify(param));
  //         console.log('Parsed JSON Response:', jsonResponse);

  //         if (jsonResponse && jsonResponse['message'] === 'OK') {
  //           console.log('Attempting to download file');
  //           this.downloadFile(Utilities.dataURItoBlob(jsonResponse['content']), format);
  //         } else {
  //           console.error('Report generation failed', { 
  //             message: jsonResponse ? jsonResponse['message'] : 'No message', 
  //             response: jsonResponse 
  //           });
  //           this.snackBar.open('Failed to generate document. Please try again.', 'Close', {
  //             duration: 3000
  //           });
  //         }
  //       } catch (parseError) {
  //         console.error('Error parsing response:', parseError);
  //         this.snackBar.open('Error processing document. Please contact support.', 'Close', {
  //           duration: 3000
  //         });
  //       }
  //     },
  //     error => {
  //       console.error('HTTP Error in report generation:', error);
  //       this.snackBar.open('Failed to generate document. Please check your connection.', 'Close', {
  //         duration: 3000
  //       });
  //     },
  //     () => {
  //       console.log('Report generation observable completed');
  //       console.groupEnd();
  //     }
  //   );
  // }

  // private downloadFile(blob: Blob, format: string = 'pdf') {
  //   try {
  //     console.log('Downloading file', { 
  //       blobSize: blob.size, 
  //       type: blob.type 
  //     });

  //     const dataURL = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = dataURL;
  //     link.download = `document.${format}`;

  //     // Append to body, click, and remove
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(dataURL);
  //     }, 100);
  //   } catch (downloadError) {
  //     console.error('Error downloading file:', downloadError);
  //     this.snackBar.open('Error downloading document. Please try again.', 'Close', {
  //       duration: 3000
  //     });
  //   }
  // }

  
  send(): void {
    if (!this.contactItem.subject || !this.contactItem.email || !this.contactItem.content) {
      this.snackBar.openFromComponent(ErrorComponent, {
        data: { message: 'Vă rugăm să completați toate câmpurile.' },
        duration: 2000,
      });
      return;
    }

    this.isLoading = true;
    this.contactSuccess = false;
    this.contactItem.date = new Date();

    this.contactUsService
      .addItem(this.contactItem)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe(
        () => {
          this.contactItem.subject = '';
          this.contactItem.email = '';
          this.contactItem.content = '';
          this.contactSuccess = true;
          this.snackBar.openFromComponent(InformationComponent, {
            data: { message: 'Mesajul a fost trimis cu succes!' },
            duration: 2000,
          });
        },
        () => {
          this.snackBar.openFromComponent(ErrorComponent, {
            data: { message: 'A apărut o eroare. Vă rugăm să încercați din nou.' },
            duration: 2000,
          });
        }
      );
  }

  isPaidDocument(group: string): boolean {
    return this.getDocumentWidgetPrice(group).price > 0;
  }

  // Method to get price details for a specific document and format
  getDocumentPriceDetails(documentUniqueName: string, format: string) {
    const documentKey = Object.keys(this.documentPrices).find(key =>
      key.toLowerCase().includes(documentUniqueName.toLowerCase()) &&
      key.toLowerCase().includes(format.toLowerCase())
    );

    return documentKey ? this.documentPrices[documentKey as DocumentPriceEnum] : null;
  }

  getDocumentWidgetPrice(documentUniqueGroup: string): { price: number, currency: string } {
    // Extrage toate valorile obiectului documentPrices
    const allPrices = Object.values(this.documentPrices);

    // Filtrează după documentUniqueGroup
    const matchingDocuments = allPrices.filter(doc =>
      doc.documentUniqueGroup.toLowerCase() === documentUniqueGroup.toLowerCase()
    );

    // Dacă nu există documente pentru acel grup, returnează default
    if (matchingDocuments.length === 0) {
      console.warn(`No documents found for group: ${documentUniqueGroup}`);
      return { price: 0, currency: 'RON' };
    }

    // Dacă nu, returnează cel mai ieftin
    const cheapest = matchingDocuments.reduce((min, current) =>
      current.documentPrice < min.documentPrice ? current : min
    );

    return { price: cheapest.documentPrice, currency: cheapest.documentCurrency };
  }

  onFormatClick(event: Event, documentUniqueName: string): void {
    event.stopPropagation();
    this.redirectToPayment(documentUniqueName);
  }
}
